import { useNavigate } from "react-router-dom";
import { openExternalLink } from "../../utils/webview";

import DividerText from "../../components/Divider/DividerText/DividerText";
import Typography from "../../components/Typography/Typography";
import LandingImage from "../../assets/landingImage.svg";
import Button from "../../components/Button/Button";
import styles from "./Landing.module.scss";

const APP_VERSION = window.env.REACT_APP_APP_VERSION || "X.X.X";
const TERMS_AND_CONDITIONS = window.env.REACT_APP_TERMS_AND_CONDITIONS;

const handleGuestLinkClick = (e) => {
    e.preventDefault();
    openExternalLink("https://juanvaldez.com/", "landing_guest");
};

const handleTermsClick = (e) => {
    e.preventDefault();
    openExternalLink(TERMS_AND_CONDITIONS, "landing_terms");
};

const Landing = () => {
	const navigate = useNavigate();

	const handleRegisterClick = () => {
		navigate("/register/validate-identity");
	};

	const handleRedirectClick = () => {
		navigate("/login");
	};

	return (
		<div className={styles.landingContainer}>
			<div className={styles.landingImageContainer}>
				<img
					src={LandingImage}
					alt="landing-img"
					className={styles.landingImg}
				></img>

				<div className={styles.landingImageContent}>
					<Button
						className={styles.landingImageBtn}
						color="white"
						onClick={handleRegisterClick}
					>
						Crear Cuenta
					</Button>
				</div>
			</div>

			<DividerText 
				text={
					<span className={styles.landingDividerText}>
						¿Ya&nbsp;te&nbsp;inscribiste?
					</span>
				}
			></DividerText>
			<Button
				className={styles.landingRedirectBtn}
				onClick={handleRedirectClick}
			>
				Soy Amigo Juan Valdez
			</Button>

			<Typography variant="p2" className={styles.landingAnonimusText}>
				¿Solo quieres explorar?{" "}
				<a
					href="https://juanvaldez.com/"
					onClick={handleGuestLinkClick}
					target="_blank"
					rel="noopener noreferrer"
					className={styles.landingAnonimusText}
				>
					Ingresa como invitado
				</a>
			</Typography>

			<div className={styles.landingLegalContainer}>
                <Typography variant="p4" className={styles.landingLegalVersion}>
                    2026. App Juan Valdez - Versión {APP_VERSION}
                </Typography>

                <Typography variant="p4" className={styles.landingLegalText}>
                    La aplicación móvil de la marca Juan Valdez es administrada y operada por
                    PROCAFECOL S.A.
                </Typography>

                <Typography variant="p4" className={styles.landingLegalText}>
                    Aplican condiciones y restricciones disponibles en{" "}
                    <a
                        href={TERMS_AND_CONDITIONS}
						onClick={handleTermsClick}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.landingLegalLink}
                    >
                        Términos y Condiciones
                    </a>
                </Typography>
            </div>
		</div>
	);
};

export default Landing;
